var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classList },
    [
      _vm.label
        ? _c("tube-label", {
            staticClass: "t-textarea__label",
            attrs: { label: _vm.label, required: _vm.required, name: _vm.name }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "t-textarea__group" }, [
        _c(
          "textarea",
          _vm._b(
            {
              ref: "textarea",
              staticClass: "t-textarea__control",
              attrs: {
                disabled: _vm.disabled,
                required: _vm.required,
                readonly: _vm.readonly,
                placeholder: _vm.placeholder,
                maxLength: _vm.maxLength,
                autocomplete: _vm.autocomplete,
                name: _vm.name,
                rows: _vm.rows,
                autofocus: _vm.autofocus,
                dir: _vm.dir
              },
              domProps: { value: _vm.internalValue },
              on: {
                focus: _vm.onFocus,
                keyup: _vm.keyup,
                keydown: _vm.keydown,
                input: _vm.onInput,
                change: _vm.onChange,
                blur: _vm.onBlur,
                click: _vm.onClick
              }
            },
            "textarea",
            _vm.$attrs,
            false
          )
        ),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "t-textarea__loader" }, [
              _c("i", { staticClass: "fas fa-circle-notch fa-fw fa-spin" })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.invalidMessage
        ? _c("div", { staticClass: "t-textarea__error" }, [
            _vm._v("\n    " + _vm._s(_vm.invalidMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "t-textarea__description" }, [
            _vm._v("\n    " + _vm._s(_vm.description) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAi
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content: !_vm.$user.eligible("ai_in_lms")
                      ? _vm.$t("generic.text.contact_support")
                      : _vm.$t("generic.tiptap.generate_with_ai")
                  },
                  expression:
                    "{content: !$user.eligible('ai_in_lms') ? $t('generic.text.contact_support') : $t('generic.tiptap.generate_with_ai'),}"
                }
              ],
              staticClass: "t-textarea__ai t-cursor--pointer",
              class: { "t-disabled-opacity": !_vm.$user.eligible("ai_in_lms") },
              on: {
                click: function($event) {
                  _vm.$user.eligible("ai_in_lms") ? _vm.openAiModal() : null
                }
              }
            },
            [
              _c("SparklesIcon", {
                staticClass: "t-comment__ai",
                attrs: { size: "18", gradient: "" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }